module.exports = __webpack_public_path__ + "img/小黑盒示例图.887ed408.jpeg";